import { Center, Text3D, useGLTF } from "@react-three/drei";
import YootMesh from "../meshes/YootMesh";
import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import Star from "../meshes/Stars/Star";
import { animated, useSpring } from "@react-spring/three";
import { useAtom } from 'jotai';
import { languageAtom } from '../GlobalState';
import translations from '../dictionaries/translations';

export default function MoAlert({ position, rotation, scale=1 }) {
  const [language] = useAtom(languageAtom);
  const fontUrl = language === 'korean' ? "/fonts/Maplestory_Bold.json" : language === 'chinese' ? "/fonts/Xiao Xiangjiao font_Regular.json" : "/fonts/Luckiest Guy_Regular.json";

  const borderMesh0Ref = useRef();
  const borderMesh1Ref = useRef();
  const borderMesh2Ref = useRef();
  const borderMesh3Ref = useRef();
  const borderMesh4Ref = useRef();
  const borderMesh5Ref = useRef();
  const borderMesh6Ref = useRef();
  const borderMeshRefs = [
    borderMesh0Ref,
    borderMesh1Ref,
    borderMesh2Ref,
    borderMesh3Ref,
    borderMesh4Ref,
    borderMesh5Ref,
    borderMesh6Ref
  ]

  const width = 3
  const height = 2.3
  useFrame((state) => {
    for (let i = 0; i < borderMeshRefs.length; i++) {      
      borderMeshRefs[i].current.position.x = Math.cos(state.clock.elapsedTime / 2 + 2 * Math.PI/borderMeshRefs.length * i) * width
      borderMeshRefs[i].current.position.y = 0.05
      borderMeshRefs[i].current.position.z = Math.sin(state.clock.elapsedTime / 2 + 2 * Math.PI/borderMeshRefs.length * i) * height
    }
  })

  function YootEmoji() {
    return <group name='yoot-emoji'>
      <YootMesh position={[-0.15, 0, 0]} rotation={[0, Math.PI/2, -Math.PI/2]} scale={0.05}/>
      <YootMesh position={[-0.05, 0, 0]} rotation={[0, Math.PI/2, -Math.PI/2]} scale={0.05}/>
      <YootMesh position={[0.05, 0, 0]} rotation={[0, Math.PI/2, -Math.PI/2]} scale={0.05}/>
      <YootMesh position={[0.15, 0, 0]} rotation={[0, Math.PI/2, -Math.PI/2]} scale={0.05}/>
    </group>
  }

  function handleAlertClick(e) {
    e.stopPropagation();
  }

  return <animated.group position={position} rotation={rotation} scale={scale} onPointerDown={(e) => handleAlertClick(e)}>
    <mesh
      castShadow
      receiveShadow
      scale={[width, 0.055, height]}
    >
      <cylinderGeometry args={[1, 1, 1, 64]}/>
      <meshStandardMaterial color='black' opacity={0.8} transparent/>
    </mesh>
    <Center position={[0, 0.09, -1.2]}>
      <group name='move-token'>
        <Star scale={0.25} color='orange' position={[-1,-0.01,-0.1]}/>
        <Star scale={0.25} color='orange' position={[-0.5,-0.01,-0.1]}/>
        <Star scale={0.25} color='orange' position={[0,-0.01,-0.1]}/>
        <Star scale={0.25} color='orange' position={[0.5,-0.01,-0.1]}/>
        <Star scale={0.25} color='orange' position={[1,-0.01,-0.1]}/>
      </group>
    </Center>
    <group name="text" position={[0, -0.15, -0.36]} scale={1.2}>
      <Center position={[0, 0.3, 0.4]} key={Math.random()}>
        <Text3D
          font={fontUrl}
          rotation={[Math.PI/2, Math.PI, Math.PI]}
          position={[-0.4, 0, -0.85]}
          size={0.95}
          height={0.01}
        >
          {translations.alerts.mo[language]}
          <meshStandardMaterial color="orange"/>
        </Text3D>
      </Center>
      <Center position={[0, 0.3, 1.5]} key={Math.random()}>
        <Text3D
          font={fontUrl}
          rotation={[Math.PI/2, Math.PI, Math.PI]}
          position={[-1.1, 0, -1.1]}
          size={0.3}
          height={0.01}
        >
          {translations.alerts.bonusThrow[language]}
          <meshStandardMaterial color="orange"/>
        </Text3D>
      </Center>
    </group>
    <group ref={borderMesh0Ref}>
      <YootEmoji/>
    </group>
    <group ref={borderMesh1Ref}>
      <Star scale={0.1} color='orange'/>
    </group>
    <group ref={borderMesh2Ref}>
      <Star scale={0.1} color='orange'/>
    </group>
    <group ref={borderMesh3Ref}>
      <Star scale={0.1} color='orange'/>
    </group>
    <group ref={borderMesh4Ref}>
      <Star scale={0.1} color='orange'/>
    </group>
    <group ref={borderMesh5Ref}>
      <Star scale={0.1} color='orange'/>
    </group>
    <group ref={borderMesh6Ref}>
      <Star scale={0.1} color='orange'/>
    </group>
  </animated.group>
}